export default "__VITE_ASSET__uDWUmAx0__"